import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import $ from 'jquery';
import authService from '../../Common/services';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

const screenCode = 'GROUP';

export function GroupListing(props) {

    const [groups, setGroups] = useState([]);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });

    const contentRowNames = ["groupCode", "groupName", "isActive"]

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGROUPLISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITGROUP');

        if (isAddEditEnabled != undefined) {
            setPermissions({
                ...permissionList,
                isAddEditEnabled: true
            });
        }

        getAllGroups();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    async function getAllGroups() {
        var data
        data = await services.getAll()
        destroyDataTable()
        setGroups(data)
        createDataTable()
    }

    function handleClick(group) {
        props.history.push({
            pathname: 'groups/addEdit',
            data: group,
            edit: true
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Groups"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Groups"
                            path="groups/addEdit" />
                        <div className="card-body">



                            <div className="table-responsive row-top-gap">
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Group Code</th>
                                            <th>Group Name</th>
                                            <th>Status</th>
                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContent
                                            data={groups}
                                            contentRowNames={contentRowNames}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            handleClick={handleClick}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


